import { render, staticRenderFns } from "./AuthorizedPickupPerson.vue?vue&type=template&id=59eac7cc&"
import script from "./AuthorizedPickupPerson.vue?vue&type=script&lang=ts&"
export * from "./AuthorizedPickupPerson.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorizedPickupPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports